import styled from '@emotion/styled';
import { theme } from '../../styles/theme';

export const PricingSectionShell = styled.section`
  padding: clamp(2rem, 5vw, 3rem) ${theme.spacing.xl};
  background: #ffffff;
  position: relative;
`;

export const PricingSectionContainer = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const PricingTitle = styled.h2`
  margin: 0 0 ${theme.spacing.md};
  text-align: center;
  font-size: clamp(1.5rem, 3vw, 2.25rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  color: var(--login-form-text);
`;

export const PricingSubtitle = styled.p`
  margin: 0 auto ${theme.spacing.xl};
  max-width: 640px;
  text-align: center;
  font-size: ${theme.typography.fontSize.lg};
  line-height: 1.6;
  color: var(--login-form-muted);
`;

export const NoHiddenFeesMessage = styled.div`
  text-align: center;
  margin: 0 auto ${theme.spacing.xl};
  max-width: 520px;
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  background: var(--login-form-input-bg);
  border-radius: 999px;
  border: 1px solid var(--login-form-border);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.sm};
  font-size: ${theme.typography.fontSize.sm};
  color: var(--login-form-muted);

  &::before {
    content: '✓';
    color: var(--login-primary);
    font-weight: 700;
  }

  span {
    color: var(--login-form-text);
    font-weight: 600;
  }
`;

export const PricingGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: ${theme.spacing.lg};
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;
